import { Link } from "react-router-dom";

export function HeroSection() {
  return (
    <section className="pt-32 pb-24 px-8 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-7">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#0066FF] mb-4">AI-Powered Content Creation</p>
          <h1 className="text-5xl sm:text-6xl tracking-tighter font-black mb-6 leading-[1.1]">
            Create Content That <span className="text-[#0066FF]">Converts</span>
          </h1>
          <p className="text-lg text-gray-600 mb-8 max-w-xl leading-relaxed">
            Generate high-quality blog posts, ads, social media content, and marketing images in seconds. Powered by GPT-5.2 and Nano Banana AI.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/register"
              className="bg-[#0066FF] text-white px-8 py-4 font-bold hover:bg-[#0052CC] transition-all hover:-translate-y-1 rounded-xl shadow-lg"
              data-testid="hero-cta"
            >
              Start Creating Free
            </Link>
            <a
              href="#features"
              className="border-2 border-black px-8 py-4 font-bold hover:bg-black hover:text-white transition-all rounded-xl"
            >
              Learn More
            </a>
          </div>
        </div>
        <div className="md:col-span-5">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/f798f628-0f80-4267-9fd3-c086d618d17d/images/65ec02c49a2bb0e309fe8f526dfa23468dac8513efaaaa42ac5d5047682756fa.png"
            alt="QAIRO AI"
            className="w-full border border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]"
          />
        </div>
      </div>
    </section>
  );
}
